import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(private _httpClient: HttpClient) {

  }

  saveInterpreterFeedback(reqId, ratingIds) {
    return new Promise((resolve, reject) => {
      this._httpClient.post(environment.apiUrl + 'request/interpreter-feedback/' + reqId, ratingIds)
        .subscribe(response => {
          resolve(response);
        }, reject)
    })
  }

  saveSchedulerFeedback(reqId, ratingIds) {
    return new Promise((resolve, reject) => {
      this._httpClient.post(environment.apiUrl + 'request/scheduler-feedback/' + reqId, ratingIds)
        .subscribe(response => {
          resolve(response);
        }, reject)
    })
  }

}
